import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { projects } from '../data/projects';
import ClassifierDemo from '../components/ClassifierDemo';
import './ProjectDetail.css';

function ProjectDetail() {
  const { id } = useParams();
  const project = projects.find((p) => p.id === id);

  if (!project) {
    return (
      <main className="detail-notfound">
        <div className="section-label">{'// 404'}</div>
        <p>Project not found.</p>
        <Link to="/projects" className="back-link">← Back to projects</Link>
      </main>
    );
  }

  return (
    <main className="detail">
      <div className="detail-header" style={{ borderLeftColor: project.color }}>
        <Link to="/projects" className="back-link">← All projects</Link>
        <div className="detail-tags">
          <span className="proj-tag" style={{ background: project.color }}>{project.tag}</span>
          {project.hasDemo && <span className="demo-badge">[ live demo ]</span>}
        </div>
        <h1 className="detail-title">{project.title}</h1>
        <div className="detail-subtitle">{project.subtitle}</div>
      </div>

      <div className="detail-body">
        <div className="detail-left">
          <div className="section-label">{'// About'}</div>
          <p className="detail-desc">{project.description}</p>

          <div className="section-label" style={{ marginTop: '24px' }}>{'// Tech stack'}</div>
          <div className="proj-tech">
            {project.tech.map((t) => (
              <span key={t} className="tech-pill">{t}</span>
            ))}
          </div>

          {project.github && (
            <a href={project.github} target="_blank" rel="noreferrer" className="github-link">
              [ view on github ] →
            </a>
          )}
        </div>

        {project.hasDemo && (
          <div className="detail-right">
            {project.demoType === 'classifier' && <ClassifierDemo color={project.color} />}
          </div>
        )}
      </div>
    </main>
  );
}

export default ProjectDetail;